import React, { useMemo } from 'react';
import UniversalTable from '../../../../components/UniversalTable/UniversalTable';
import { useLanguage } from '../../../../LanguageProvider';

export default function CollaboratorsTable({ headers, data, fieldMapping }) {
  const { getTranslation } = useLanguage();

  const columns = useMemo(() => (
    (Array.isArray(headers) ? headers : []).map(h => ({
      key: fieldMapping?.[h],
      header: h
    }))
  ), [headers, fieldMapping]);

  return (
    <UniversalTable
      data={data}
      columns={columns}
      containerClassName="table-container"
      tableClassName="collaborators-table"
      emptyText={getTranslation("noData")}
    />
  );
}